import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.125 9.10547C8.43668 9.10547 9.5 8.04215 9.5 6.73047C9.5 5.41879 8.43668 4.35547 7.125 4.35547C5.81332 4.35547 4.75 5.41879 4.75 6.73047C4.75 8.04215 5.81332 9.10547 7.125 9.10547Z"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.00879 15.0424C3.00879 13.9506 3.44251 12.9035 4.21453 12.1315C4.98656 11.3595 6.03365 10.9258 7.12546 10.9258C8.21726 10.9258 9.26435 11.3595 10.0364 12.1315C10.8084 12.9035 11.2421 13.9506 11.2421 15.0424"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.667 4.91016C13.115 5.0825 13.5003 5.38657 13.7721 5.78228C14.0439 6.178 14.1893 6.64678 14.1893 7.12682C14.1893 7.60687 14.0439 8.07565 13.7721 8.47136C13.5003 8.86708 13.115 9.17115 12.667 9.34349"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2998 11.2422C14.124 11.4899 14.8498 11.9897 15.3752 12.6713C15.9006 13.353 16.1992 14.1821 16.229 15.0422"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
